import useStore from 'bz-stores/hook/mobx-inject/useStore';
import type AuthStore from 'bz-stores/lib/auth-store';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import Rupt from 'rupt';
import { cache } from 'tm3-core/cache';
import { isAlsoNonProd, isNonProd } from '../context';

export const RuptProvider = observer(() => {
  const authStore = useStore<typeof AuthStore>('authStore');
  const [deviceId, setDeviceId] = useState('');

  let client_id = '3b034d9f-9fab-485d-acb9-dee6664c28d8';
  if (isNonProd || isAlsoNonProd) client_id = '3a56625e-874f-48c3-900e-476c595b733f';
  if (cache.app.Click) client_id = '35898ac3-4845-4f09-b70e-1cc91c1bbe56';
  else if (cache.app.EClinic) client_id = '7bbbd8e1-9d08-482f-8a85-ed829221409d';
  else if (cache.app.Caseflow) client_id = '367b9fc8-5a1b-4059-96e8-e47b7affee6b';
  else if (cache.app.PPM) client_id = 'ecc6a4e0-36f8-4414-b54d-235f977a8ad9';

  useEffect(() => {
    if (authStore.user && authStore.user.isAuthenticated) {
      const { email, mobileNumber, displayName, isEvaluating, clientId, location } = authStore.user;
      if (!deviceId)
        Rupt.attach({
          client_id,
          account: clientId.toString(),
          metadata: {
            displayName,
            isEvaluating,
            location: location?.name
          },
          email, // Optional
          phone: mobileNumber, // Optional
          redirect_urls: {
            logout_url: `${window.location.host}/logout`,
            new_account_url: 'https://www.clearcoursehealth.com'
          }
        }).then((res) => setDeviceId(res?.device_id ?? ''));
    }
  }, [deviceId]);
  return null;
});
